var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconTableview = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("line", { strokeWidth: "1", x1: "4", y1: "22", x2: "26", y2: "22" }),
                React.createElement("line", { strokeWidth: "1", x1: "4", y1: "12", x2: "26", y2: "12" }),
                React.createElement("line", { strokeWidth: "1", x1: "4", y1: "17", x2: "26", y2: "17" }),
                React.createElement("line", { strokeWidth: "1", x1: "11", y1: "12", x2: "11", y2: "26" }),
                React.createElement("line", { x1: "6.7", y1: "8", x2: "18.7", y2: "8" }),
                React.createElement("path", { d: "M4.5,2.5h21c1.1,0,2,0.9,2,2v21c0,1.1-0.9,2-2,2h-21c-1.1,0-2-0.9-2-2v-21C2.5,3.4,3.4,2.5,4.5,2.5z" })))));
});
export default IconTableview;
//# sourceMappingURL=IconTableview.js.map